// Generated by export-landing-graphic-scene.mjs. Do not hand edit.
import scene320 from './dragon-graphic-320.webp';
import scene640 from './dragon-graphic-640.webp';
import scene960 from './dragon-graphic-960.webp';
import scene1086 from './dragon-graphic-1086.webp';

export const dragonScene = { src: scene960, srcSet: `${scene320} 320w, ${scene640} 640w, ${scene960} 960w, ${scene1086} 1086w`, width: 1086, height: 1448 } as const;
